export const C_STATUS_TRUST = {
  YES: { label: "Si", value: "yes" },
  NO: { label: "No", value: "no" },
  PENDING: { label: "En proceso", value: "pending" }
};


export const A_STATUS_TRUST = [
  C_STATUS_TRUST.YES,
  C_STATUS_TRUST.NO,
  C_STATUS_TRUST.PENDING
];
